<form [formGroup]="formGroup">
  <div class="d-flex flex-column gap-4">
    <div class="form-grid">
      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" for="primaryPhoneNumber" i18n>Primary Phone Number</label>
        <app-phone-country-code
          controlId="primaryPhoneNumber"
          phoneNumberControlName="primaryPhoneNumber"
          countryCodeControlName="primaryPhoneNumberCountryCode"
          [countryCodes]="(countryCodes$ | async) ?? []"
          [formGroup]="formGroup"
          [error]="formSubmitted && formGroup.invalid && !formGroup.controls.primaryPhoneNumber.value" />
      </div>

      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" for="secondaryPhoneNumber" i18n>Secondary Phone Number</label>
        <app-phone-country-code
          controlId="secondaryPhoneNumber"
          phoneNumberControlName="secondaryPhoneNumber"
          countryCodeControlName="secondaryPhoneNumberCountryCode"
          [countryCodes]="(countryCodes$ | async) ?? []"
          [formGroup]="formGroup"
          [error]="formSubmitted && formGroup.invalid && !formGroup.controls.secondaryPhoneNumber.value" />
        <small class="form-input-hint" i18n>Optional</small>
      </div>
    </div>

    <app-form-error
      *ngIf="formSubmitted && formGroup.errors?.atLeastOnePhoneNumber"
      [errors]="formGroup.errors"
      [customErrorMessages]="customErrorMessages.phoneNumbers" />

    <ng-container *ngIf="filesRequired">
      <hr class="mt-3" />

      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" for="file" i18n>Document</label>
        <app-file-upload-field
          controlId="file"
          formControlName="files"
          [accept]="acceptedFileTypes"
          [multiple]="allowMultipleFiles"
          [maxFileSizeInMb]="maxFileSizeInMb"
          [submitAttempted]="formSubmitted"
          [control]="formGroup.controls.files"
          [showThumbnail]="true">
          <div class="d-flex flex-column align-items-center gap-3" input-copy>
            <img
              src="assets/icons/grey/FileUpload.svg"
              alt="Upload File"
              i18n-alt
              height="24"
              width="24"
              [style.height.rem]="1.5"
              [style.width.rem]="1.5" />
            <app-file-uploader-text
              [disabled]="formGroup.controls.files.disabled"
              descriptionText="or drag and drop .png or .jpeg up to 3MB"
              i18n-descriptionText />
          </div>
        </app-file-upload-field>
        <app-form-error
          *ngIf="formSubmitted && formGroup.controls.files.invalid"
          [errors]="formGroup.controls.files.errors"
          [customErrorMessages]="customErrorMessages.files" />
      </div>
    </ng-container>
  </div>
</form>
